import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { Icon } from '../icon/Icon';
import { makeNativeLink, makeNotNativeLink, makeNoFollowLink, makeDisabledLink, makeLinkIcon, makeAnchorLink, } from './mixins';
const NativeLinkComponent = styled(NavLink) `
  ${(props) => makeNativeLink(props)}
`;
const NotNativeLinkComponent = styled.a `
  ${(props) => makeNotNativeLink(props)}
`;
const NoFollowLinkComponent = styled.span `
  ${(props) => makeNoFollowLink(props)}
`;
const DisabledLinkComponent = styled.span `
  ${(props) => makeDisabledLink(props)}
`;
const LinkIcon = styled(Icon) `
  ${(props) => makeLinkIcon(props)}
`;
const AnchorLinkComponent = styled.a `
  ${(props) => makeAnchorLink(props)}
`;
const NativeLink = (props) => {
    const { href, icon, children, linkoptions = { size: 'medium' } } = props;
    let { reactRouterOptions } = props;
    if (!reactRouterOptions || (reactRouterOptions && !('pathname' in reactRouterOptions))) {
        reactRouterOptions = Object.assign(Object.assign({}, reactRouterOptions), { pathname: href });
    }
    return (React.createElement(NativeLinkComponent, Object.assign({}, props, linkoptions, { content: children, to: Object.assign({}, reactRouterOptions) }),
        icon && React.createElement(LinkIcon, Object.assign({}, icon, { linkoptions: linkoptions, content: children })),
        children));
};
const NotNativeLink = (props) => {
    const { icon, children, linkoptions = { size: 'medium' } } = props;
    return (React.createElement(NotNativeLinkComponent, Object.assign({}, props, linkoptions, { content: children }),
        icon && React.createElement(LinkIcon, Object.assign({}, icon, { linkoptions: linkoptions, content: children })),
        children));
};
const NoFollowLink = (props) => {
    const { link, icon, children, linkoptions = { size: 'medium' } } = props;
    const redirect = () => {
        window.location.href = link;
    };
    return (React.createElement(NoFollowLinkComponent, Object.assign({}, props, linkoptions, { content: children, rel: "nofollow", "data-url": `${link}`, onClick: () => redirect() }),
        icon && React.createElement(LinkIcon, Object.assign({}, icon, { linkoptions: linkoptions, content: children })),
        children));
};
const DisabledLink = (props) => {
    const { icon, children, linkoptions = { size: 'medium' } } = props;
    return (React.createElement(DisabledLinkComponent, Object.assign({}, props, linkoptions, { content: children }),
        icon && React.createElement(LinkIcon, Object.assign({}, icon, { linkoptions: linkoptions, content: children })),
        children));
};
const AnchorLink = (props) => {
    const { icon, children, linkoptions = { size: `medium` }, openContactAgentClick } = props;
    const scrollToSection = (section) => window.scrollTo({ top: section, behavior: 'smooth' });
    const getScrollToSectionId = (element) => element.target.getAttribute('href');
    const scroll = (ref) => {
        ref.preventDefault();
        const sectionId = getScrollToSectionId(ref);
        if (sectionId) {
            const section = document.getElementById(sectionId.substring(1));
            if (!section) {
                return;
            }
            const sectionOffsetTop = section.offsetTop;
            scrollToSection(sectionOffsetTop);
        }
    };
    return (React.createElement(AnchorLinkComponent, Object.assign({}, props, { onClick: (ref) => {
            openContactAgentClick && openContactAgentClick();
            scroll(ref);
        }, content: children }),
        icon && React.createElement(LinkIcon, Object.assign({}, icon, { linkoptions: linkoptions, content: children })),
        children));
};
export const Link = (props) => {
    const { linkoptions, disabled = false, noFollow = false } = props;
    if (disabled)
        return DisabledLink(props);
    if (noFollow)
        return NoFollowLink(props);
    if (linkoptions && linkoptions.native)
        return NativeLink(props);
    if (linkoptions && linkoptions.anchor)
        return AnchorLink(props);
    return NotNativeLink(props);
};
